import type { FormSegment, LookalikeFormSegment, LookalikeSegmentDefinition } from '../../../../types';
import type { UseLookalikeSegmentsSelectionReturn, UseSegmentSelectionReturn } from './hooks/types';

export const isFormSegment = (item: FormSegment | LookalikeSegmentDefinition): item is FormSegment => {
  return 'name' in item && !('lookalike_name' in item);
};

export const isFormSegmentArray = (items: FormSegment[] | LookalikeSegmentDefinition[]): items is FormSegment[] => {
  return Array.isArray(items) && items.every(item => 'name' in item && !('lookalike_name' in item));
};

export const isFormSegmentSelectionReturnType = (
  segmentSelectionProps: UseSegmentSelectionReturn | UseLookalikeSegmentsSelectionReturn
): segmentSelectionProps is UseSegmentSelectionReturn => {
  return 'directSegments' in segmentSelectionProps;
};

export const isLookalikeSegmentDefinition = (
  item: FormSegment | LookalikeSegmentDefinition
): item is LookalikeSegmentDefinition => {
  return 'lookalike_name' in item;
};

export const isLookalikeFormSegmentArray = (
  items: LookalikeFormSegment[] | FormSegment[] | undefined
): items is LookalikeFormSegment[] => {
  if (!Array.isArray(items)) return false;

  return (
    Array.isArray(items) &&
    items.every(item => typeof item === 'object' && item !== null && 'lookalike_definition_id' in item)
  );
};
